import { useEditor } from "features/editor/Feature";
import { Button } from "prism-react";

import { useAnalytics } from "hooks/useAnalytics";

import { useEmbedModal } from "./useEmbedModal";

export const EmbedButton: React.FC<{
  editorURL: URL;
}> = ({ editorURL }) => {
  const track = useAnalytics();
  const editor = useEditor();
  const { open } = useEmbedModal({ editorURL });

  return (
    <Button
      icon="fileHtml"
      onClick={() => {
        open();

        track("embed_open_modal", {
          type:
            editor.type === "branch"
              ? "branch"
              : editor.isCloud
                ? "cloud_sandbox"
                : "browser_sandbox",
        });
      }}
      variant="secondary"
    >
      Embed
    </Button>
  );
};
